import { classNames as cn } from "tools/ui";

const KIND_CONFIG = {
  delivery: {
    label: "Delivery",
    color: "bg-amber-300 text-black border-amber-700",
  },
  take_away: {
    label: "Take Away",
    color: "bg-blue-300 text-white border-blue-700",
  },
  to_table: {
    label: "To Table",
    color: "bg-green-300 text-white border-green-700",
  },
  catering: {
    label: "Catering",
    color: "bg-purple-300 text-white border-purple-700",
  },
};

function LabelKind({ kind }) {
  const config = KIND_CONFIG[kind];

  if (!config) {
    return null;
  }

  return (
    <div
      className={cn(
        "px-2 py-1 rounded text-xs font-semibold uppercase border",
        config.color,
      )}
    >
      {kind}
    </div>
  );
}

export default LabelKind;
